/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export interface StructuredAddress {
    /** 2 char country code, for example: \'us\', \'ee\', \'gb\' */
    country_code: string | null;
    /** min length: 1, max length: 255 */
    region: string | null;
    /** min length: 1, max length: 30 */
    postcode: string | null;
    /** min length: 1, max length: 255 */
    city_name: string | null;
    /** min length: 1, max length: 255 */
    street_name: string | null;
    /** min length: 1, max length: 30 */
    building_number: string | null;
    /** min length: 1, max length: 30 */
    flat_number: string | null;
    /** min length: 0, max length: 255 */
    suburb?: string | null;
    /** min length: 0, max length: 255 */
    fallback_address?: string;
}
